module.exports = __webpack_public_path__ + "img/GWhatsApp-App-Info.68053f86.webp";